
import React,{useEffect,useState} from 'react';
import { Button,InputLabel,Box,Select,MenuItem,Checkbox,FormControlLabel,Typography } from '@material-ui/core';
import API from 'util/Api';
import {saveAs} from "file-saver"

const Actions = (props) => {
    console.log("upload-subsc-props", props);
    const [uploadType,setUploadType]=useState(null);
    const [selectedClient,setSelectedClient]=useState(null);
    const [file,setFile] = useState(undefined);
    const [value,setValue] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [consentAccepted, setConsentAccepted] = useState(false);
    useEffect(()=>{
        setFile(undefined);
        setValue(null);
        setUploadType(null);
        setConsentAccepted(false);
    },[props.selectedLoc])
    const uploadExcel = (e)=>{
        
        if(file){
            const data = new FormData();
            data.append('file', file);
            data.append('location_id', props.selectedLoc.location_id);
            data.append('type',uploadType);
            data.append('client_id',selectedClient);
            data.append('consent_accepted', consentAccepted ? '1' : '0');
            setIsSubmitting(true);
            API.post('upload_access_users',data)
            .then((res) => {
                // received data        
                console.log('rcvd data',res.data)
                props.renderSnack({open:true,msg:res.data.msg,type:'success'});
                setFile(undefined);
                setValue(null);
                setUploadType(null);
                setConsentAccepted(false);
                setIsSubmitting(false);
                props.updateList();
            })
            .catch((err) => {
                try{
                    props.renderSnack({open:true,msg:err.response.data.msg,type:'error'})
                }catch{
                    props.renderSnack({open:true,msg:"Something went wrong",type:'error'})
                }
                // got an error
                console.log('err',err.response)
                setIsSubmitting(false);
            })
        }else{
            props.renderSnack({open:true,msg:"Choose File",type:'error'})
        }
        console.log("uploadExcel",file)
    }
    const dwnloadSamples =(key)=>{
        var data={
            "location_id":props.selectedLoc.location_id,
            "subscription_type":key
        }
        API.get('subscriptionSampleExcel?data='+JSON.stringify(data))
        .then((res) => {
            saveAs(res.data.data);
        })
        .catch((err) => {
            // got an error
        })
    }
    return(
          <>
            <div className="row" style={{marginTop:20}}>
            <div className="col-12" style={{display:"flex",flexWrap:"wrap",marginBottom:40}}>
                <Box ml="15px" mb={"10px"}><Button variant="contained" color="primary" onClick={()=>dwnloadSamples('access_clients_subscription')}> Download Client's Subscription upload sample  </Button>
                </Box>
                <Box ml="15px" mb={"10px"}><Button variant="contained" color="primary" onClick={()=>dwnloadSamples('access_clients_code')}> Download Client's Code  </Button>
                </Box>
                <Box ml="15px" mb={"10px"}><Button variant="contained" color="primary" onClick={()=>dwnloadSamples('access_clients_users')}> Download Client's User upload sample  </Button>
                </Box>
                {
                  props.selectedLoc.role=='master'&&
                    <Box ml="15px" mb={"10px"} ><Button variant="contained" color="primary" onClick={()=>dwnloadSamples('access_users')}> Download User upload sample  </Button>
                    </Box>
                }
                
            </div>
            {/* Access Type */}
                <div className={'col-sm-4 col-md-4 col-12 '}  >
                    <InputLabel id="demo-simple-select-helper-label">Select Upload Type</InputLabel>
                    <Select
                        value={uploadType}
                        onChange={(e)=>{
                            setUploadType(e.target.value);
                            setSelectedClient(null);
                            setFile(null);
                            setValue('');
                            setConsentAccepted(false);
                        }}
                        displayEmpty
                        fullWidth
                        inputProps={{ 'aria-label': 'Without label' }}
                        >
                            <MenuItem value={"client_subscription"}>{"New Client Subscription"}</MenuItem>
                            <MenuItem value={"client_users"}>{"Client Users"}</MenuItem>
                            {
                              props.selectedLoc.role=='master'&&
                                <MenuItem value={"users"}>{"Location Users "}</MenuItem>
                            }
                    </Select>
                </div>
            {
            ['client_users','users','client_subscription'].includes(uploadType)&&

                <div className={'col-sm-4 col-md-4 col-12'} style={{padding:15}} >
                    <input style={{display:'flex'}} value={value} type="file" accept=".xls,.xlsx" name="myfile" onChange={e=>{setValue(e.target.value);setFile(e.target.files[0])}}/>
                </div> 
            }
            </div>
            <div className="row" style={{marginTop:20}}>
                {['client_users','users','client_subscription'].includes(uploadType)&&
                   <div className={'col-12'} style={{marginBottom:16}}>
                        <FormControlLabel
                            style={{alignItems:'center', margin:0}}
                            control={
                                <Checkbox
                                    color="primary"
                                    checked={consentAccepted}
                                    onChange={(e)=>setConsentAccepted(e.target.checked)}
                                />
                            }
                            label={
                                <Typography component="span" style={{lineHeight:1.4}}>
                                    By uploading employee data you confirm that you have obtained the necessary consent and act as the Data Fiduciary under the DPDP Act.
                                </Typography>
                            }
                        />
                    </div>
                }
                {['client_users','users','client_subscription'].includes(uploadType)&&
                   <div className={'col-sm-4 col-md-4 col-12'}  >
                        <Button  variant="contained" color="primary" mr="5px" disabled={isSubmitting || !consentAccepted} onClick={()=>{uploadExcel()}}> Upload</Button>
                    </div> 
                }
            </div>
            
            
        </> 
    )
}

export default Actions;
